var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "thankyou-step" },
    [
      _c("div", { staticClass: "ty-icon", class: _vm.iconClass }, [
        !_vm.isDeclined
          ? _c(
              "svg",
              {
                attrs: {
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M20 6L9 17L4 12",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]
            )
          : _c(
              "svg",
              {
                attrs: {
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M18 6L6 18M6 6l12 12",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]
            ),
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "ty-title" }, [_vm._v(_vm._s(_vm.heading))]),
      _vm._v(" "),
      _c("p", { staticClass: "ty-subtitle" }, [_vm._v(_vm._s(_vm.subtitle))]),
      _vm._v(" "),
      _c("div", { staticClass: "ty-body" }, [
        _vm.isPending
          ? _c("p", [
              _vm._v(
                "We're working quickly to review your application. Please allow "
              ),
              _c("strong", [_vm._v("1–2 business days")]),
              _vm._v(
                " for processing — we'll email you with an update as soon as we have one."
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isPending
          ? _c("p", [
              _vm._v(
                "Keep an eye on your inbox for any emails from Flash Money. In the meantime, you can check your application status by logging in."
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isApproved
          ? _c("p", [
              _vm._v(
                "Great news! Your application has been approved. Log in to your Flash Money account to review your loan agreement and next steps."
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isDeclined
          ? _c("p", [
              _vm._v(
                "Unfortunately we're unable to proceed with your application at this time. If you have any questions, please contact our team — we're happy to help."
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ty-steps" }, [
        _c("div", { staticClass: "ty-step ty-step--done" }, [
          _c("div", { staticClass: "ty-step__dot" }, [
            _c(
              "svg",
              { attrs: { viewBox: "0 0 16 16", fill: "currentColor" } },
              [
                _c("path", {
                  attrs: {
                    d: "M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.86-8.736z",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "ty-step",
            class: _vm.isPending ? "ty-step--active" : "ty-step--done",
          },
          [
            _c(
              "div",
              {
                staticClass: "ty-step__dot",
                class: _vm.isPending ? "ty-step__dot--pulse" : "",
              },
              [
                !_vm.isPending
                  ? _c(
                      "svg",
                      { attrs: { viewBox: "0 0 16 16", fill: "currentColor" } },
                      [
                        _c("path", {
                          attrs: {
                            d: "M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.86-8.736z",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ty-step__text" }, [
              _c("span", { staticClass: "ty-step__label" }, [
                _vm._v("Under review"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "ty-step__note" }, [
                _vm._v(
                  _vm._s(
                    _vm.isPending
                      ? "Our team is assessing your application"
                      : "Assessment complete"
                  )
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ty-step", class: _vm.decisionStepClass }, [
          _c(
            "div",
            { staticClass: "ty-step__dot", class: _vm.decisionDotClass },
            [
              _vm.isApproved
                ? _c(
                    "svg",
                    { attrs: { viewBox: "0 0 16 16", fill: "currentColor" } },
                    [
                      _c("path", {
                        attrs: {
                          d: "M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.86-8.736z",
                        },
                      }),
                    ]
                  )
                : _vm.isDeclined
                ? _c(
                    "svg",
                    { attrs: { viewBox: "0 0 16 16", fill: "currentColor" } },
                    [
                      _c("path", {
                        attrs: {
                          d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z",
                        },
                      }),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ty-step__text" }, [
            _c("span", { staticClass: "ty-step__label" }, [
              _vm._v(_vm._s(_vm.decisionLabel)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "ty-step__note" }, [
              _vm._v(_vm._s(_vm.decisionNote)),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn-fm btn-fm-primary ty-cta",
          attrs: { href: "/login" },
        },
        [
          _c(
            "svg",
            {
              staticStyle: {
                width: "14px",
                height: "14px",
                "margin-right": "6px",
              },
              attrs: {
                viewBox: "0 0 16 16",
                fill: "currentColor",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10 3.5a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 1 0v2A1.5 1.5 0 0 1 9.5 14h-8A1.5 1.5 0 0 1 0 12.5v-9A1.5 1.5 0 0 1 1.5 2h8A1.5 1.5 0 0 1 11 3.5v2a.5.5 0 0 1-1 0v-2z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z",
                },
              }),
            ]
          ),
          _vm._v("\n    Log in to Flash Money\n  "),
        ]
      ),
      _vm._v(" "),
      _vm._t("controls", null, null, { prev: null, next: null }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ty-step__text" }, [
      _c("span", { staticClass: "ty-step__label" }, [
        _vm._v("Application submitted"),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "ty-step__note" }, [
        _vm._v("Done — we've received your details"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }